import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../services/api';

type Me = { ok: true; email: string; kaiin_code: number; full_name?: string; vip_status: number; is_admin: number };

const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await apiClient.get('/api/auth/me') as unknown as Me;
        if (!cancelled) setChecked(true);
      } catch {
        if (!cancelled) {
          const next = encodeURIComponent(location.pathname + location.search);
          navigate(`/login?next=${next}`, { replace: true });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [location.pathname, location.search, navigate]);

  if (!checked) {
    return (
      <div style={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }
  return <>{children}</>;
};

export default AuthGate;
